//TODO: スタブ型なのでcustomerに持っていく
export interface TransportBox {
    /**
     * 箱名
     */
    boxName: string,
    /**
     * 箱の重さ
     */
    boxWeight: number,
    /**
     * 冷蔵時の保冷剤の重さ
     */
    refrigeratedWeight?: number,
    /**
     * 冷凍時の保冷剤の重さ
     */
    frozenWeight?: number,
}

export function getBoxList(): TransportBox[] {
    return [
        {
            boxName: "輸送容器①",
            boxWeight: 724,
            refrigeratedWeight: 2888,
            frozenWeight: 2812
        },
        {
            boxName: "輸送容器②",
            boxWeight: 730,
            refrigeratedWeight: 2516,
        },
        {
            boxName: "輸送容器③黒",
            boxWeight: 610,
            frozenWeight: 1217
        },
        {
            boxName: "輸送容器③青",
            boxWeight: 600,
            refrigeratedWeight: 994
        }
    ];
}

export function getBox(boxName: string): TransportBox | undefined {
    const boxList = getBoxList();
    return boxList.find(box => box.boxName === boxName);
}